import { supabase } from "@/lib/supabase";

/**
 * A `functions.invoke` hibánál csak „non-2xx" üzenetet ad vissza; a tényleges
 * okot (pl. tiltott címzett) a válasz törzse tartalmazza.
 */
async function edgeErrorMessage(error: unknown, fallback: string): Promise<string> {
  const context = (error as { context?: unknown })?.context;
  if (context instanceof Response) {
    try {
      const json = (await context.clone().json()) as { error?: string };
      if (json.error) return json.error;
    } catch {
      // Nem JSON válasz — marad az általános üzenet.
    }
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}

/** Típusos Edge Function hívás egységes hibaüzenettel. */
export async function invokeEdgeFunction<T>(
  name: string,
  body: Record<string, unknown>,
  fallbackError: string
): Promise<T> {
  const result = await supabase.functions.invoke<T>(name, { body });
  if (result.error) throw new Error(await edgeErrorMessage(result.error, fallbackError));
  if (result.data === null || result.data === undefined) throw new Error(fallbackError);
  return result.data;
}
